import { normalizePhoneNumber } from '@super/shared-types'
import { ContactWithRelationships } from '@super/shared-types'

/**
 * Normalize contacts by creating a consistent formatting
 * @param contacts - The contacts to normalize
 * @returns The normalized contacts
 */
export function normalizeContacts(
  contacts: ContactWithRelationships[],
): ContactWithRelationships[] {
  return contacts.map(contact => ({
    ...contact,
    primaryPhoneNumber: normalizePhoneNumber(contact.primaryPhoneNumber),
  }))
}
